// ─── QR Code Activity Category ────────────────────────────────────────────────
export enum EStatus {
  Active = 'Active',
  InActive = 'In-Active',
}

export enum EFramework {
  Individual = 'Individual',
  Group = 'Group',
  OneToOne = '1-1',
}

export type QRCodeActivityCategory = {
  _id?: string;
  originId?: string;
  name: string;
  framework?: EFramework | string;
  accessibility: 'Internal' | 'External';
  status: EStatus;
  lastUpdatedBy: string;
  createdAt: string;
  updatedAt: string;
  hostByChannel?: string;
  hostByRoles?: string[];
  sortOrder?: number | string | null;
};

export type QRCodeActivityCategoryPaginateList = {
  items: QRCodeActivityCategory[];
  totalRecords: number;
  totalPages: number;
};

export type QRCodeActivityCategoryListParam = {
  name?: string;
  accessibility?: string;
  framework?: EFramework | string;
  createdAtFrom?: Date | null;
  createdAtTo?: Date | null;
  status?: EStatus | string;
  categoryId?: string;
  page: number;
  limit: number;
};

// ─── QR Code Activity Type ────────────────────────────────────────────────────

export type QRCodeActivityType = {
  _id?: string;
  originId?: string;
  name: string;
  description?: string;
  category?: QRCodeActivityCategory | string;
  categoryId: string;
  framework?: EFramework | string;
  enableLocationName: boolean;
  enableNote: boolean;
  status: EStatus;
  accessibility: 'Internal' | 'External';
  createdAt: string;
  updatedAt: string;
  updatedBy: string;
  sortOrder?: number | null | string;
};

export type QRCodeActivityTypePaginateList = {
  items: QRCodeActivityType[];
  totalRecords: number;
  totalPages: number;
};

export type QRCodeActivityTypeListParam = {
  name?: string;
  categoryId?: string;
  accessibility?: string;
  framework?: EFramework | string;
  createdAtFrom?: Date | null;
  createdAtTo?: Date | null;
  status?: EStatus | string;
  page: number;
  limit: number;
  select?: string;
};

export type CategoryOption = { value: string; label: string; framework: string };

// ─── QR Activity Report ───────────────────────────────────────────────────────

export type QRActivityReport = {
  activityName: string;
  activityType: string;
  category: string;
  framework?: EFramework | string;
  activityCreatedDate?: string;
  activityStartDate: string;
  activityEndDate: string;
  hostAgentCode: string;
  hostOfficeCode: string;
  attendanceAgentCode: string;
  checkInAt: string;
};

export type QRActivityReportPaginateList = {
  items: QRActivityReport[];
  totalRecords: number;
  totalPages: number;
};

export type QRActivityReportListParam = {
  availableFrom?: Date | null;
  availableTo?: Date | null;
  attendanceAgentCode?: string;
  hostAgentCode?: string;
  activityName?: string;
  activityType?: string;
  category?: string;
  framework?: string;
  officeCode?: string;
  checkInAt?: string;
  sortBy?: string;
  page: number;
  limit: number;
};
